import { render, staticRenderFns } from "./TemplateOverrideSettings.vue?vue&type=template&id=302fd8a4&scoped=true"
import script from "./TemplateOverrideSettings.vue?vue&type=script&lang=js"
export * from "./TemplateOverrideSettings.vue?vue&type=script&lang=js"
import style0 from "./TemplateOverrideSettings.vue?vue&type=style&index=0&id=302fd8a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302fd8a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('302fd8a4')) {
      api.createRecord('302fd8a4', component.options)
    } else {
      api.reload('302fd8a4', component.options)
    }
    module.hot.accept("./TemplateOverrideSettings.vue?vue&type=template&id=302fd8a4&scoped=true", function () {
      api.rerender('302fd8a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screens/screen/TemplateOverrideSettings.vue"
export default component.exports